import React, { Component } from "react";

import moment from "moment";

export class Footer extends Component {
  render() {
    return (
      <div
        className="footer bg-white py-4 d-flex flex-lg-column"
        id="kt_footer"
      >
        <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between">
          <div className="text-dark order-2 order-md-1">
            <span className="text-muted font-weight-bold mr-2">
              © {moment().format("YYYY")}
            </span>
            <a href="#" className="text-dark-75 text-hover-primary">
              Clinks
            </a>
          </div>

          <div className="nav nav-dark order-1 order-md-2">
            <a
              href="mailto: customerservice@clinks.ie"
              target="_blank"
              className="nav-link btn btn-primary btn-pill"
            >
              <i className="flaticon-support" /> Support
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
